import {
  quick_search_repository,
  search_repository,
} from '@/repositories';

const QUICK_SEARCH_ITEMS_LIMIT = 6;

const state = () => ({
  quick_search_input: '',
});

const getters = {
  quickSearchInput: (state) => state.quick_search_input,
};

const actions = {
  setQuickSearchInput({ commit }, quick_search_input) {
    commit('set_quick_search_input', quick_search_input);
  },
  async getQuickSearchResults(_, quick_search) {
    const criteria = {
      quick_search,
      limit: QUICK_SEARCH_ITEMS_LIMIT,
    };

    const result = await quick_search_repository.getQuickSearchResults(criteria);

    return result;
  },
  async searchAccountQuicksearch(_, input) {
    const result = await search_repository.searchAccountQuicksearch(input);

    return result.account_list;
  },
};

const mutations = {
  set_quick_search_input(state, quick_search_input) {
    state.quick_search_input = quick_search_input;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
